import { TableHeaderItem } from "@/views/components/YtoTable/TableHeaderItem";

const defaultWidth = 300;

const tableHeader: TableHeaderItem[] = [
  { prop: 'index', label: '序号', width: null },
  { prop: 'wayBillNo', label: '实物条码', width: null },
  { prop: 'strScanTime', label: '扫描时间', width: null },
  { prop:'latticeNo',label:"末端线/矩阵格口号", width:null},
  { prop: 'state', label: '状态', width: null },
  { prop: 'strTip', label: '提示/警告信息', width: null },
];
export default { tableHeader }
